<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>PARAMETROS DE HERRAMIENTAS COMPLETAS</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Conf_Param_hdx</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del parametro"
                                v-model="filtro.palabraClave"
                                @keydown.enter.native="obtenerConfiguracionHerramientasCompletas"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" class="m-3" v-if="$localStorageService.can('Conf_01_Param_hdx_crear')">
              <b-button variant="outline-success"
                        @click="agregar()"
              >Crear Parametro
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(flujo)="row">
              <span>{{row.item.flujo.flujoExpedienteDigial}}</span>
            </template>
            <template v-slot:cell(archivo)="row">
              <span>{{row.item.archivo.nombreHerramienta}}</span>
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    v-if="$localStorageService.can('Conf_01_Param_hdx_edit')"
                    title="Modificar parámetro"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button
                    v-if="!row.item.registroActivo && $localStorageService.can('Conf_01_Param_hdx_act')"
                    title="Activar parámetro"
                    variant="outline-danger"
                    size="sm"
                    @click="activarDesactivarParametro(row.item)"
                >
                  <em v-if="!row.item.loader" class="fa fa-undo"></em>
                  <b-spinner v-else small></b-spinner>
                </b-button>
                <b-button v-else-if="$localStorageService.can('Conf_01_Param_hdx_act')"
                          title="Desactivar parámetro"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarParametro(row.item)"
                >
                  <b-icon v-if="!row.item.loader" icon="trash-fill"></b-icon>
                  <b-spinner v-else small></b-spinner>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        no-close-on-backdrop no-close-on-esc
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="flujo">Flujo
                </label>
                <validacion/>
                <v-select id="flujo" name="flujo" placeholder="Seleccione el flujo"
                          label="flujoExpedienteDigial"
                          :options="listaFlujoExpedinteDigital"
                          v-model="herramienta.flujo"
                          @input="obtenerArchivoExpedientePorFlujo()"
                ></v-select>
              </b-form-group>

              <b-form-group align="left">
                <label for="nombreArchivo">Herramienta
                </label>
                <validacion/>
                <v-select id="nombreArchivo" name="nombreArchivo" placeholder="Seleccione herramienta"
                          label="nombreHerramienta"
                          :options="listaArchivoExpedinteDigital"
                          v-model="herramienta.archivo"
                ></v-select>
              </b-form-group>
              <b-form-group align="left">
                <label for="cantidadArchivo">Cantidad requerida de archivos
                </label>
                <validacion/>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input id="cantidadArchivo" name="cantidadArchivo" placeholder="Cantidad requerida"
                                type="number"
                                min="1" max="6" maxLength="2"
                                v-model="$v.herramienta.numeroMinimoArchivos.$model"
                                :state="validateState('numeroMinimoArchivos')"
                                pattern="[0-9]{1,}"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import { numeric, required} from "vuelidate/lib/validators";

export default {
  name: "configuracionHdxCompletas",
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "flujo", label: "Flujo", sortable: true},
        {key: "archivo", label: "Herramienta", sortable: true},
        {key: "numeroMinimoArchivos", label: "Cantidad Archivos", sortable: true},
        "Acciones",
      ],
      filtro: {
        palabraClave: null,
      },
      registrosPorPagina: 10,
      paginaActual: 1,
      tituloModal: '',
      loaderAcciones: false,
      show: false,
      herramienta: {
        idParametrosFlujo: null,
        flujo: null,
        archivo: null,
        numeroMinimoArchivos: null,
      },
      loader: false,
      listaHerramientas: [],
      listaHerramientasSDI: [],
      listaTipoArchivoHerramientasSDI: [],
      listaRutaFlujo: [],
      listaFlujoExpedinteDigital: [],
      listaArchivoExpedinteDigital: [],
      indexModificar: null,
      blnEditar: false
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerConfiguracionHerramientasCompletas();
    // this.obtenerHerramientasSDI();
    this.obtenerTipoArchivoHerramientaSDI()
    this.obtenerTipoFlujo();
    this.obtenerFlujosExpediente();
  },
  validations() {
    return {
      herramienta: {
        numeroMinimoArchivos: {required, numeric},
        archivo: {required},
        flujo: {required}
      }
    }
  },
  methods: {
    obtenerConfiguracionHerramientasCompletas() {
      this.loader = true;
      this.$http
          .post(this.$api + "herramientaExpedienteElectronico/obtenerParametrosECE",this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.herramienta[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
    agregar() {
      this.herramienta = {
        flujo: null,
        nombreArchivo: null,
        tipoArchivo: null,
        cantidadArchivos: null,
        numeroMinimoArchivos:"",
      }
      this.tituloModal = 'Agregar parámetro';
      this.show = true;
    },
    guardar() {
      this.$v.herramienta.$touch();
      if (this.$v.herramienta.$anyError) {
        return;
      }
      if (this.herramienta.numeroMinimoArchivos < 1) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Favor de corregir la cantidad máxima de archivos antes de guardar ",
        });
        return;
      }
      if (!this.$v.herramienta.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'herramientaExpedienteElectronico/guardarParametroECE', this.herramienta).then(respuesta => {
              if (respuesta.data.data) {
                this.cerrarModal();
                this.filtro ={
                  palabraClave: null,
                }
                this.obtenerConfiguracionHerramientasCompletas();
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: respuesta.data.message
                })
              }else{
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: respuesta.data.message
                });
              }
            }
        ).catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: error.message,
          });
        }).finally(() => {
              this.loaderAcciones = false;
              this.indexModificar = null;
            }
        )
      }
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
      this.indexModificar = null;
      this.blnEditar = false;
    },
    obtenerHerramientasSDI(flujo) {
      this.$http
          .get(this.$api + "rutaExpediente/obtenerHerramientasSDI?flujo=" + flujo)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaHerramientasSDI = respuesta.data.data;
            }
          })
          .finally(() => {
          });
    },
    obtenerTipoFlujo() {
      this.$http
          .get(this.$api + "rutaExpediente/GetTipoFlujo")
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaRutaFlujo = respuesta.data.data;
            }
          })
          .finally(() => {
          });
    },
    obtenerTipoArchivoHerramientaSDI() {
      this.herramienta.tipoArchivo = null;
      this.herramienta.cantidadArchivos = null;
      this.$http.get(this.$api + "rutaExpediente/obtenerTipoHerramientaSDI"
          /* +"?herremienta="+herramienta*/
      ).then((respuesta) => {
        if (respuesta.data.data) {
          this.listaTipoArchivoHerramientasSDI = respuesta.data.data;
        }
      })
          .finally(() => {
          });
    },
    eliminarParametro(item) {
      this.$swal({
        icon: "warning",
        text: '¿Está seguro de eliminar la configuración, sera irreversible?',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const index = this.listaHerramientas.findIndex(h => h.nombreArchivo === item.nombreArchivo);
          if (index >= 0) {
            this.listaHerramientas.splice(index, 1);
            let parametro = JSON.stringify(this.listaHerramientas);
            let parametroscompletos = {
              "uri": '[{"listArchivos":' + parametro + '}]'
            }
            this.$http.post(this.$api + 'rutaExpediente/guardarConfiguracionHdxCompletas', parametroscompletos).then(respuesta => {
                  if (respuesta.data.data) {
                    this.obtenerConfiguracionHerramientasCompletas();
                    this.show = false;
                    this.$swal.fire({
                      icon: "info",
                      title: "Aviso",
                      text: "La configuracion se eliminó correctamente"
                    });
                  }
                }
            )
          }
        }
      })
    },
    obtenerFlujosExpediente() {
      this.$http.get(this.$api + 'catalogos/obtenerFlujoExpedinteDigital').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaFlujoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    obtenerArchivoExpedientePorFlujo() {
      this.listaArchivoExpedinteDigital = [];
      this.$http.post(this.$api + 'herramientaExpedienteElectronico/obtenerHerramientasECEFlujo', this.herramienta.flujo).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaArchivoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    modificar(item) {
      this.herramienta = Object.assign({}, item);
      this.obtenerArchivoExpedientePorFlujo();
      this.tituloModal = 'Modificar parámetro';
      this.show = true;
      this.blnEditar = true;
    },
    activarDesactivarParametro(item) {
      // item.loader = true;
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el parámetro?' : '¿Está seguro de activar el parámetro?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.loader = true;
          const parametros = {
            idParametrosFlujo: item.idParametrosFlujo,
          }
          this.$http.post(this.$api + 'herramientaExpedienteElectronico/activarDesactivarParametro', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  this.loader = false;
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El parámetro se actualizó correctamente",
                  });
                }
              }
          )
        } else {
          item.loader = false;
        }
      })
    },
  }
}
</script>

<style>

</style>
